import * as yup from 'yup'

import { ForgotPasswordFields } from './forgotPassword.types'

export const forgotPasswordSchema = yup.object().shape({
    [ForgotPasswordFields.usernameEmail]: yup.string().required('AUTH.REQUIRED_FIELD'),
})
